import { useQuery } from 'react-query';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

// item 868a — the CUSTOMER REQUESTS queue: every portal submission Pulse hasn't priced-and-sent
// yet (drafts included, so we see what's coming). The nav badge counts SUBMITTED only.
export interface CustomerRequestRow {
  id: string;
  proposalNumber: string;
  title: string;
  customerName?: string | null;
  projectId: string;
  projectName?: string | null; // item 1018 — null while it sits in the hidden drafts bucket
  assigned?: boolean; // item 1018 — true = filed into a REAL project (not the drafts bucket)
  submitted: boolean; // true = awaiting review; false = the customer is still building
  createdDate: string;
  lastModifiedDate: string;
  venueCount: number;
  docCount: number;
}

const useCustomerRequests = (enabled = true) => {
  const query = useQuery(
    'customerRequests',
    async (): Promise<CustomerRequestRow[]> => {
      const { data } = await axios.get(`${apiUrl}proposal/customer-requests`);
      return data;
    },
    { enabled, staleTime: 60_000, refetchInterval: 120_000 },
  );
  const rows = query.data ?? [];
  return {
    ...query,
    rows,
    submittedCount: rows.filter((r) => r.submitted).length,
  };
};

export default useCustomerRequests;
